import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SurveyComponent } from './survey/survey.component';
import { IntroComponent } from './intro/intro.component'
import { OutroComponent } from './outro/outro.component'
import { ErrorComponent } from './error/error.component';

import {SurveyGuardService} from './services/surveyGuardService'

const routes: Routes = [
  //pt non-LOCAL
  {component: SurveyComponent, path: 'survey/:surveyId', canActivate: [SurveyGuardService]}, 
  {component: IntroComponent, path: 'intro/:surveyId', canActivate: [SurveyGuardService]},
  //END regiune non-LOCAL

  //pt LOCAL
  // {component: SurveyComponent, path: 'survey/:surveyId'}, 
  // {component: IntroComponent, path: 'intro/:surveyId'},
  //END regiune LOCAL
  {component: OutroComponent, path: 'outro'},
  {path:'**', component: ErrorComponent }
];//TODO add error path

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
